/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

function MultiSeriesDonutViewChart({ data }: any) {
  const [dataState, setDataState] = useState<any>([]);
  const [state, setState] = useState<any>({
    series: [],
    options: {
      chart: {
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
          barLabels: {
            enabled: true,
            useSeriesColors: true,
            offsetX: -8,
            fontSize: "16px",
            formatter(seriesName: string, opts: any) {
              return `${seriesName}:  ${opts.w.globals.series[opts.seriesIndex]}`;
            },
          },
        },
      },
      colors: ["#1ab7ea", "#0084ff", "#39539E", "#0077B5"],
      labels: [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              show: false,
            },
          },
        },
      ],
    },
  });

  useEffect(() => {
    if (data?.length) {
      const result = data.flatMap((item: any) =>
        item.data.map((subItem: any) => ({
          label: `${subItem.category} ${item.name}`,
          value: subItem.value,
        }))
      );
      setDataState([...result]);
    } else {
      setDataState([]);
    }
  }, [data]);

  useEffect(() => {
    if (dataState?.length) {
      setState({
        options: {
          ...state.options,
          labels: dataState?.map((item: any) => item?.label),
        },
        series: dataState?.map((item: any) => Number(item?.value.toFixed(2))),
      });
    } else {
      setState({
        options: {
          ...state.options,
          labels: [],
        },
        series: [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataState]);

  return state?.series?.length ? (
    <ReactApexChart
      options={state.options}
      series={state.series}
      type="radialBar"
    />
  ) : null;
}

export default MultiSeriesDonutViewChart;
